<script>
import TransitionExpand from "@/components/transition-expand.vue";

import sizeVue from "~/src/mixins/size.vue";

import Step1 from "./step-1.vue";
import Step2 from "./step-2.vue";
import Step3 from "./step-3.vue";
import Step4 from "./step-4.vue";

export default {
  props: {
    isReadonly: {
      type: Boolean,
      default: () => false,
    },
  },

  components: {
    TransitionExpand,
    Step1,
    Step2,
    Step3,
    Step4,
  },

  data: () => ({
    currentStep: 1,
    steps: 4,
  }),

  mixins: [sizeVue],

  methods: {
    onNextStep() {
      if (this.currentStep < this.steps) {
        this.currentStep++;
      } else {
        this.currentStep--;
      }
    },

    onPrevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
  },
};
</script>

<template>
  <div>
    <v-container>
      <v-stepper elevation="0" v-model="currentStep" class="custom-stepper">
        <v-stepper-header v-if="size.width > 576">
          <template v-for="n in steps">
            <v-stepper-step
              :key="`${n}-step`"
              :complete="currentStep > n"
              :class="currentStep > n && 'stepper-step-complate'"
              :step="n"
              :editable="currentStep > n"
              :edit-icon="`${n}`"
            />
            <v-divider
              class="header-divider"
              :key="`${n}-divider`"
              v-if="n < steps"
            />
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content :step="1">
            <div style="padding-top: 30px"></div>
            <step-1
              :isReadonly="isReadonly"
              v-if="currentStep == 1"
              @next="onNextStep"
              @prev="onPrevStep"
            />
          </v-stepper-content>

          <v-stepper-content :step="2">
            <div style="padding-top: 30px"></div>
            <transition-expand>
              <step-2
                :isReadonly="isReadonly"
                v-if="currentStep == 2"
                @next="onNextStep"
                @prev="onPrevStep"
              />
            </transition-expand>
          </v-stepper-content>

          <v-stepper-content :step="3">
            <div style="padding-top: 30px"></div>
            <transition-expand>
              <step-3
                :isReadonly="isReadonly"
                v-if="currentStep == 3"
                @next="onNextStep"
                @prev="onPrevStep"
              />
            </transition-expand>
          </v-stepper-content>

          <v-stepper-content :step="4">
            <div style="padding-top: 30px"></div>
            <transition-expand>
              <step-4
                :isReadonly="isReadonly"
                v-if="currentStep == 4"
                @next="onNextStep"
                @prev="onPrevStep"
              />
            </transition-expand>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <div class="py-4"></div>
    </v-container>
  </div>
</template>

<style lang="scss">
$roudSize: 58px;
$innerRoudSize: 54px;

.custom-stepper {
  max-width: 1164px;
  margin-left: auto;
  margin-right: auto;

  background-color: #f3eefb !important;

  @media only screen and(min-width:577px) {
    margin-top: 15px;
  }

  .v-stepper__header {
    box-shadow: none;
  }

  .v-stepper__step {
    &,
    &:hover {
      border-radius: 50%;
      padding: 0;
      height: $roudSize;
      width: $roudSize;
      justify-content: center;
      background-color: #f3eefb;

      .v-stepper__label {
        display: none;
      }

      .v-stepper__step__step {
        margin: 0 !important;
        height: $innerRoudSize;
        width: $innerRoudSize;
        background: #d9d9d9 !important;

        border: 4px solid white !important  ;

        i {
          font-size: 0.75rem !important;
          font-style: normal !important;
        }
      }

      &.stepper-step-complate {
        .v-stepper__step__step {
          background: #00274c !important;
        }
      }

      &.v-stepper__step--active {
        background: #00274c !important;

        .v-stepper__step__step {
          background: #00274c !important;
        }
      }
    }
  }

  .v-stepper__content {
    padding: 0;
  }
}

.text-field {
  border-radius: 10px;

  .v-input__slot {
    background-color: #ebf0f8 !important;
    box-shadow: none !important;
  }

  &.error--text {
    .v-input__slot {
      background-color: #fddee2 !important;
      box-shadow: 0 0 8px #fddee2;
    }
  }

  &.v-input--is-disabled {
    opacity: 0.7;
  }
}

.header-divider {
  border-width: 0px 0px 3px;
  transform: translateY(-6px);
  margin: 0 -2px !important;
}

.card-header {
  background-color: #00274c;
  height: 90px;
}
</style>
